import useSWR from 'swr'

import { useRootContext } from '../context'

export function useShowExitPrompt() {
  const { api } = useRootContext()

  const { data } = useSWR(['all', 'tasks'], api.tasks.getAllDirectTasks, {
    revalidateOnFocus: false,
  })

  if (!data?.data) return false

  const hasEmployments = data.data.length > 0

  return hasEmployments
}
